import { httpPost } from "../../../../../modules/Backend";
import AdobeComboBox from "../../../../AdobeAriaLib/AdobeComboBox";
import { IOption } from "../../../../AdobeAriaLib/AdobeSelect";
import { useEffect, useState } from "react";

interface IFormDisposalCheckOperatorSelect {
    value: string
    label: string
    required: boolean
    onChange: Function
    disabled?: boolean
}

export default function FormDisposalCheckOperatorSelect({ value, disabled, label, required, onChange }: IFormDisposalCheckOperatorSelect) {
    const [options, setOptions] = useState<IOption[]>([])

    function handleChange(val: string) {
        onChange(val)
    }

    function isDisabled() {
        return disabled ?? false
    }

    async function getData() {
        try {
            const result = await httpPost(`api/disposalChecks/listValidDisposalCheckers`, {})
            if (result.data && result.data.operators) {
                const operatorOptions: IOption[] = result.data.operators.map((operator: { id: string; name: string }) => ({
                    value: operator.id,
                    text: operator.name
                }))
                setOptions(operatorOptions)
            }
        }
        catch (err) {
        }
    }

    useEffect(() => {
        getData()
    }, [])

    return (
        <div>
            <AdobeComboBox
                value={value}
                label={label}
                labelVisible={true}
                options={options}
                required={required}
                onChangeSelect={handleChange}
                disabled={isDisabled()}
                selectionMode="single" />
        </div>
    )
}
